export default "__VITE_ASSET__CXJU_fxy__"